import React, { useEffect, useState } from 'react';

/**
 * GurgenclerLansman2026: Apple lansman dönemi (Eylül 2026) hazırlık sunumu.
 * Route: /r/gurgencler-lansman-2026 (sidebar YOK, tam ekran slayt gösterisi)
 *
 * 29 slayt, 16:9, beyaz. Her slaydın sol altında Gürgençler, sağ altında
 * Glowytics logosu. İçerik statik HTML: rakamlar üretim anında GA4 + Google Ads
 * + Keyword Planner çekiminden hesaplanıp gömüldü (deck-data.json).
 * Yeniden üretmek için: node src/pages/gurgencler-lansman/build.js
 *
 * 🔑 "PDF olarak indir" düğmesi belgenin İÇİNDE. iframe dışından Ctrl+P
 * slaytları tek sayfaya kırpar; düğmeyi dışarı taşıma.
 *
 * HTML modülü ~113KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function GurgenclerLansman2026() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./gurgenclerLansmanHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#17120E">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--paper-2) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F3EEE9' }} />;

  return (
    <iframe
      title="Gürgençler · Apple Lansman Dönemi 2026"
      srcDoc={html}
      style={fill}
    />
  );
}
